import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { totalState } from '../store/totalState';

export const useUpdateTotal = (data?: any) => {
  const setTotal = useSetRecoilState(totalState);
  useEffect(() => {
    if (data) setTotal(data.count);
  }, [data]);
};